module.exports = __webpack_public_path__ + "static/media/B_peach_bloom.84c75501.png";